import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'custom-radio-button',
  template: `
    <input type="radio" [name]="name" [id]="id" [value]="value" [(ngModel)]="selected" (ngModelChange)="handleCheckedChange()" [attr.disabled]="disabled ? 1 : null">
    <label [for]="id"><label>
  `,
  styleUrls: ['./checkbox.css']
})
export class CustomRadioButtonComponent {
  @Input() name: string
  @Input() value: number
  @Input() selected: number
  @Input() disabled: boolean
  @Output() selectedChange = new EventEmitter<number>();

  id: number = Math.floor(Math.random()*1000)

  handleCheckedChange() {
    this.selectedChange.emit(this.value)
  }

  click() {
    if (this.disabled) return

    this.selected = this.value
    this.selectedChange.emit(this.value)
  }
}
